import React from 'react'
// Leaf imports, not the `src/live` barrel: this component is eager on every /mentor-home/* page,
// and the barrel re-exports `./providers` -> `./rtc`, which statically pulls every RTC adapter
// (agora + daily + 100ms + zoom) into the signalling chunk.
import ProviderSignalingBridge from 'src/live/signaling/components/ProviderSignalingBridge'
import { SIGNALING_PROVIDERS } from 'src/live/providerIds'

export default function AgoraSignallingComponent(props) {
  return (
    <ProviderSignalingBridge
      {...props}
      signalingProvider={SIGNALING_PROVIDERS.agoraRtm}
    />
  )
}
